
import SavedVehicle from 'JS/components/automotive/SavedVehicle.vue';
import { createRadioBase } from 'JS/components/blain-form/BRadioBase';
import { defineComponent } from 'vue';
import { ICustomerVehicle } from 'JS/types/Automotive';
import { PropType } from 'vue';

const { withRadioBaseProps, useRadioBase } = createRadioBase();

export default defineComponent({
	name: 'CustomerVehicleRadio',
	components: {
		SavedVehicle,
	},
	props: {
		...withRadioBaseProps(),
		vehicle: { type: Object as PropType<ICustomerVehicle>, required: true },
	},
	setup(props, { emit }) {
		return {
			...useRadioBase(props, emit),
		};
	}
});

